import { render, staticRenderFns } from "./UserTabs.vue?vue&type=template&id=06924b80&"
import script from "./UserTabs.vue?vue&type=script&lang=ts&"
export * from "./UserTabs.vue?vue&type=script&lang=ts&"
import style0 from "./UserTabs.vue?vue&type=style&index=0&id=06924b80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports